import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {PickArtifactCreaturesNavPanel} from "@/scenes.ui/pick-artifact-creatures-nav-panel";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import {ArtifactSlot, UnlockState} from "@/scenes.ui/artifact-slot";
import {Artifact} from "@/store/artifact/types";
import ArtifactUtils from "@/utils/artifact-utils";
import CU from "@/utils/c-u";

export class CreaturePickArtifactBonusPanel extends HorizontalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, creatures: Creature[],
                artifact: Artifact, callback: (artifactId: number, creatureId: number) => unknown) {
        super(scene, canvas, Tr('vibor.geroja'));

        let choseCreatureText = TextUtils.addTextByFamily(scene, Tr('a.teper.viberem.geroja.kotoriy.poluchit.') + String(Math.floor(artifact.effectValue * 0.25)) + ' ' + ArtifactUtils.getEffectTypeGenetive(artifact.effectType)!.toUpperCase(),
            0, 30, '#fff4da', 13, 'normal', 350, Fonts.ARIAL_MT);

        let artifactSlot = new ArtifactSlot(scene, 0, -80 * CU.S, 110, artifact, false, UnlockState.UNLOCKED, () => undefined).setScale(CU.S, CU.S);

        let creaturesNavPanel = new PickArtifactCreaturesNavPanel(scene, canvas, 0, 130, creatures, (creatureId: number) => {
            if (callback != null) {
                callback(artifact.id, creatureId);
            }
            this.close();
        });

        this.add([choseCreatureText, artifactSlot, creaturesNavPanel]);
    }
}
